import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-23ba03c4")

_pushScopeId("data-v-23ba03c4")
const _hoisted_1 = {
  key: 0,
  class: "pw-continue-play player-adon"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("svg", {
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M5 5L15 15",
    class: "stroke",
    "stroke-width": "2",
    "stroke-linecap": "round"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M5 15L15 5",
    class: "stroke",
    "stroke-width": "2",
    "stroke-linecap": "round"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  class: "cont-play-arrow",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M8.00001 8.73444C8.00001 7.13218 9.7458 6.14062 11.1219 6.96127L23.132 14.1234C24.4748 14.9241 24.4748 16.8689 23.132 17.6697L11.1219 24.8319C9.7458 25.6526 8 24.661 8 23.0587L8.00001 8.73444Z",
    class: "play-arrow"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.showEndedPage && !_ctx.pressed_close)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: "cont-plya-close",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.clickClose()))
        }, [
          _hoisted_2
        ]),
        _createVNode("div", {
          class: "pw-continue-play-button",
          onClick: _cache[2] || (_cache[2] = () => _ctx.updateWithFullVideo())
        }, [
          _hoisted_3,
          _createVNode("span", {
            class: "cont-plat-txt",
            innerHTML: _ctx.cont_play_btn_txt
          }, null, 8, ["innerHTML"])
        ])
      ]))
    : _createCommentVNode("", true)
})